<section class="cz-home-component no-container-padding custome-mat" [@fadeInUpAnimation] (click)="closeSnackBar()">
  <header class="page-header">
    <h1 class="page-title">{{'$my_zone_nav_secondary_dashboard' | translate}}<mat-icon (click)="openHelpDialog()">error_outline</mat-icon></h1>
  </header>
  <mat-tab-group [selectedIndex]="selectedTabIndex">
      <mat-tab>
        <ng-template mat-tab-label><span [innerHTML]="'$nav_tabs_tasks' | translate"></span><span class="font-size-small badge" [ngClass]="isTaskOverdue ? 'active' : 'primary'">{{ taskBadgeValue }}</span></ng-template>
        <ng-template matTabContent>
          <cz-tasks
            [tasksCompletedForUser$]="tasksCompletedForUser$"
            [tasksCompletedByUser$]="tasksCompletedByUser$"
            [tasksOpenAndTheSubjectIsUser$]="tasksOpenAndTheSubjectIsUser$"
            [tasksOpenAndAssignedToUser$]="tasksOpenAndAssignedToUser$"
            [selectedAccordionIndex]="selectedAccordionIndex"></cz-tasks>
        </ng-template>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
            <span [innerHTML]="'$nav_tabs_notifications' | translate"></span><span class="font-size-small badge primary">{{ notificationBadgeValue }}</span>
        </ng-template>
        <ng-template matTabContent>
          <cz-notifications
            [notificationsForUser$]="notificationsForUser$"
            [showActions]="true"></cz-notifications>
        </ng-template>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span [innerHTML]="'$nav_tabs_recommendations' | translate"></span><span class="font-size-small badge primary">{{ recommendationBadgeValue }}</span>
        </ng-template>
        <ng-template matTabContent>
          <cz-recommendations
            [recommendationsOpenForUser$]="recommendationsOpenForUser$"
            [recommendationsCompletedForUser$]="recommendationsCompletedForUser$"></cz-recommendations>
        </ng-template>
      </mat-tab>

      <!--<mat-tab label="My team" disabled>
        <div class="container-fluid">
          <div class="row">
            <div class="col-xs-12">
              <h2>Team content</h2>
            </div>
          </div>
        </div>
      </mat-tab> -->
    </mat-tab-group>
</section>
